/* B2B Portal — full JS with metric/imperial, file uploads, presets in Jacket, conditional contrasts, stock fabrics dropdown, inline validation */
(function(){
  const cfg = window.B2B_CFG || {};
  const $ = (s,r=document)=>r.querySelector(s);
  const $$= (s,r=document)=>Array.from(r.querySelectorAll(s));
  const num = v => { const x=parseFloat(String(v??'').replace(',','.')); return isFinite(x)?x:''; };

  /* ========= DATA ========= */

// ---- Safe DOM getters ----
const el  = (sel) => document.querySelector(sel);
const val = (sel) => {
  const e = el(sel);
  return e && 'value' in e ? (e.value ?? '') : '';
};
const setVal = (sel, v='') => { const e = el(sel); if (e && 'value' in e) e.value = v; };


  // Monogram & contrasts (internal codes)
  const THREADS_MONO = [
    { code:'1000', hex:'#ffffff' }, { code:'331',  hex:'#b4b4b4' }, { code:'1222', hex:'#cbb29b' },
    { code:'1182', hex:'#795e43' }, { code:'111',  hex:'#703246' }, { code:'825',  hex:'#012f64' },
    { code:'822',  hex:'#001c3b' }, { code:'950',  hex:'#02291b' }, { code:'4004', hex:'#000000' },
    { code:'120',  hex:'#ffe24c' }, { code:'122',  hex:'#fdac21' }, { code:'504',  hex:'#cb2f19' },
    { code:'67',   hex:'#ff95c8' }, { code:'1490', hex:'#b67ecd' }, { code:'314',  hex:'#028b8b' },
    { code:'338',  hex:'#339ad6' }, { code:'247',  hex:'#027c41' }, { code:'1210', hex:'#637d4f' }
  ];

  // Jacket presets (apply only to jacket customization)
  const PRESETS = {
    Coimbra: {
      jacket: { pockets:'Patch', ticket:false, lapel:'Notch', shoulderPad:'Natural',
                canvas:'Half canvas', lining:'Half', amf:'AMF 2mm', contrasts:'None' }
    },
    Lisboa: {
      jacket: { pockets:'Flap', ticket:true, lapel:'Notch (Wide)', shoulderPad:'Classic',
                canvas:'Half canvas', lining:'Full', amf:'AMF 2mm', contrasts:'None' }
    },
    Porto: {
      jacket: { pockets:'Jetted', ticket:true, lapel:'Notch (Wide)', shoulderPad:'Natural',
                canvas:'Deconstructed', lining:'Half', amf:'AMF 6mm', contrasts:'None' }
    }
  };

  // Stock service fabrics (VBC) — substitui por lista real quando tiveres
  const STOCK_FABRICS = [
    'VBC Perennial 110s Navy',
    'VBC Perennial 110s Charcoal',
    'VBC Perennial 110s Mid Grey',
    'VBC Tropical 4-ply Navy',
    'VBC Flannel Grey'
  ];

  /* ========= SWATCHES ========= */

  function swatchRow(fieldId, current){
    return `
      <div class="swatches" id="${fieldId}">
        ${THREADS_MONO.map(t => `
          <label class="swatch ${current===t.code?'active':''}">
            <input type="radio" name="${fieldId}" value="${t.code}" data-hex="${t.hex}" ${current===t.code?'checked':''}>
            <span class="dot" style="background:${t.hex}"></span>
            <span>${t.code}</span>
          </label>
        `).join('')}
        <label class="swatch ${current==='None'?'active':''}">
          <input type="radio" name="${fieldId}" value="None" data-hex="">
          <span class="dot" style="background:transparent;border:1px dashed #c0c0c0"></span>
          <span>None</span>
        </label>
      </div>
      <div class="help">Choose by internal code. “None” disables this option.</div>
    `;
  }
  function getSelectedThread(containerSel){
    const c = $(containerSel); if(!c) return 'None';
    const inp = c.querySelector('input[type="radio"]:checked');
    if (!inp) return 'None';
    if (inp.value === 'None') return 'None';
    return { code: inp.value, hex: inp.dataset.hex || '' };
  }
  function selectThread(containerSel, codeOrNone){
    const c = $(containerSel); if(!c) return;
    c.querySelectorAll('.swatch').forEach(s=>s.classList.remove('active'));
    let inp;
    if (!codeOrNone || codeOrNone==='None') inp = c.querySelector('input[value="None"]');
    else inp = c.querySelector(`input[value="${CSS.escape(codeOrNone)}"]`);
    if (inp){ inp.checked = true; inp.closest('.swatch').classList.add('active'); }
  }
  function wireSwatchClicks(containerSel){
    const c = $(containerSel); if(!c) return;
    c.querySelectorAll('.swatch').forEach(sw=>{
      sw.addEventListener('click', ()=>{
        c.querySelectorAll('.swatch').forEach(s=>s.classList.remove('active'));
        sw.classList.add('active');
      });
    });
  }

  /* ========= UNIT CONVERSION ========= */

  let UNIT = 'metric'; // 'metric' or 'imperial'
  const IN_TO_CM = 2.54;
  const LB_TO_KG = 0.45359237;

  function toCM(value){ // numeric inches -> cm if imperial; else assume cm
    const v = num(value); if (v==='') return '';
    return UNIT==='imperial' ? +(v*IN_TO_CM).toFixed(2) : v;
  }
  function kgFrom(value){ // numeric kg or lb -> kg
    const v = num(value); if (v==='') return '';
    return UNIT==='imperial' ? +(v*LB_TO_KG).toFixed(2) : v;
  }
  function refreshUnitPlaceholders(){
    const lenInputs = $$('.len'); // all measurement inputs
    lenInputs.forEach(i=>{
      const base = i.dataset.label || 'Value';
      i.placeholder = UNIT==='imperial' ? `${base} (in)` : `${base} (cm)`;
    });
    const h = $('#client_height'); if (h) h.placeholder = UNIT==='imperial' ? 'Height (in)' : 'Height (cm)';
    const w = $('#client_weight'); if (w) w.placeholder = UNIT==='imperial' ? 'Weight (lb)' : 'Weight (kg)';
  }

  /* ========= FILE HELPERS ========= */

  async function fileToPayload(input){
    const f = input?.files?.[0]; if (!f) return null;
    const data = await new Promise((res,rej)=>{
      const r = new FileReader();
      r.onload = () => res(String(r.result));
      r.onerror = rej;
      r.readAsDataURL(f); // data:image/...;base64,XXXX
    });
    return { name:f.name, type:f.type, data };
  }

  /* ========= HTML ========= */

  const html = {
    shell: (pname,pemail)=>`
      <div class="box">
        <h3>Partner</h3>
        <div class="grid-3">
          <label>Partner name <input id="partner_name" type="text"></label>
          <label>Partner email <input id="partner_email" type="email"></label>
          <label>Units
            <select id="unit_sel">
              <option value="metric">Metric (cm/kg)</option>
              <option value="imperial">Imperial (in/lb)</option>
            </select>
          </label>
        </div>
      </div>

      <div class="box">
        <h3>Client profile</h3>
        <div class="grid-3">
          <label>Find existing client
            <select id="client_select"><option value="">— Select —</option></select>
            <span class="small">Pick to autofill; or leave empty to create new.</span>
          </label>
          <label>Client full name <input id="client_name" type="text" required></label>
          <label>Client email <input id="client_email" type="email" placeholder="optional"></label>
          <label>Phone <input id="client_phone" type="tel" placeholder="optional"></label>
          <label>Height <input id="client_height" class="len" type="number" inputmode="decimal" data-label="Height"></label>
          <label>Weight <input id="client_weight" type="number" inputmode="decimal" placeholder="Weight"></label>
          <label>Front photo <input id="client_photo_front" type="file" accept="image/*"></label>
          <label>Side photo <input id="client_photo_side" type="file" accept="image/*"></label>
        </div>
        <label>Notes <textarea id="notes" rows="2" placeholder="Notes for production"></textarea></label>
      </div>

      <div class="box">
        <h3>Items</h3>
        <div class="grid-3">
          <label class="kv"><input type="checkbox" id="it_jacket"> Jacket</label>
          <label class="kv"><input type="checkbox" id="it_trouser"> Trouser</label>
          <label class="kv"><input type="checkbox" id="it_waistcoat"> Waistcoat</label>
        </div>
        <hr class="sep">

        <div id="blk_jacket" style="display:none">
          <h4>Jacket — measurements</h4>
          <div class="grid-4">
            <label>Biceps <input id="jk_biceps" class="len" data-label="Biceps" inputmode="decimal"></label>
            <label>Wrist <input id="jk_wrist" class="len" data-label="Wrist" inputmode="decimal"></label>
            <label>Chest <input id="jk_chest" class="len" data-label="Chest" inputmode="decimal"></label>
            <label>Stomach <input id="jk_stomach" class="len" data-label="Stomach" inputmode="decimal"></label>
            <label>Shoulder-to-shoulder <input id="jk_shoulder_width" class="len" data-label="Shoulder width" inputmode="decimal"></label>
            <label>Back jacket length <input id="jk_back_length" class="len" data-label="Back length" inputmode="decimal"></label>
            <label>Sleeve length <input id="jk_sleeve_length" class="len" data-label="Sleeve length" inputmode="decimal"></label>
          </div>

          <h4>Jacket — customization</h4>
          <div class="grid-4">
            <label>Apply preset
              <select id="preset_select">
                <option value="">— None —</option>
                ${Object.keys(PRESETS).map(p=>`<option value="${p}">${p}</option>`).join('')}
              </select>
            </label>

            <label>Pockets
              <select id="jk_pockets"><option>Patch</option><option>Flap</option><option>Jetted</option></select>
            </label>
            <label>Ticket pocket <select id="jk_ticket"><option>No</option><option>Yes</option></select></label>

            <label>Lapel <select id="sty_lapel"><option>Notch</option><option>Notch (Wide)</option><option>Peak</option></select></label>
            <label>Shoulder pad <select id="jk_shoulder_pad"><option>Classic</option><option>Natural</option><option>No shoulder pad</option></select></label>
            <label>Canvas construction <select id="jk_canvas"><option>Half canvas</option><option>Deconstructed</option></select></label>
            <label>Lining style <select id="jk_lining"><option>Full</option><option>Half</option><option>Unlined</option><option>Butterfly</option></select></label>
            <label>AMF stitching <select id="jk_amf"><option>No AMF</option><option>AMF 2mm</option><option>AMF 6mm</option></select></label>

            <label>Enable buttonhole contrasts
              <select id="ct_enable"><option>No</option><option>Yes</option></select>
            </label>
          </div>

          <div id="ct_block" style="display:none">
            <h4>Contrasts (buttonholes)</h4>
            <label>Lapel buttonhole color</label>
            ${swatchRow('ct_lapel','None')}
            <label>First sleeve buttonhole color</label>
            ${swatchRow('ct_sleeve','None')}
          </div>

          <label>Jacket notes <textarea id="jk_obs" rows="2"></textarea></label>
          <hr class="sep">
        </div>

        <div id="blk_trouser" style="display:none">
          <h4>Trouser — measurements</h4>
          <div class="grid-4">
            <label>Waist <input id="tr_waist" class="len" data-label="Waist" inputmode="decimal"></label>
            <label>Hips <input id="tr_hips" class="len" data-label="Hips" inputmode="decimal"></label>
            <label>Leg length <input id="tr_leg_length" class="len" data-label="Leg length" inputmode="decimal"></label>
            <label>Crotch <input id="tr_crotch" class="len" data-label="Crotch" inputmode="decimal"></label>
            <label>Thigh <input id="tr_thigh" class="len" data-label="Thigh" inputmode="decimal"></label>
            <label>Knee <input id="tr_knee" class="len" data-label="Knee" inputmode="decimal"></label>
            <label>Calf <input id="tr_calf" class="len" data-label="Calf" inputmode="decimal"></label>
            <label>Cuff finished <input id="tr_cuff" class="len" data-label="Cuff finished" inputmode="decimal" placeholder="e.g. 4"></label>
          </div>

          <h4>Trouser — customization</h4>
          <div class="grid-4">
            <label>Pleats <select id="tr_pleats"><option>0</option><option>1</option><option>2</option></select></label>
            <label>Back pockets <select id="tr_back_pockets"><option>1 with button</option><option>2 with buttons</option></select></label>
            <label>Waistband <select id="tr_waistband"><option>Belt loops</option><option>Side adjusters</option></select></label>
            <label>Hem finish <select id="tr_hem"><option>Plain</option><option>Cuff 4 cm</option></select></label>
          </div>

          <h4>Buttons (trouser)</h4>
          <div class="grid-3">
            <label>Source <select id="tr_buttons_source"><option>Stock service</option><option>Client supplied</option></select></label>
            <label>Details / ref. <input id="tr_buttons_ref" type="text" placeholder="If client supplied, ref"></label>
          </div>

          <label>Trouser notes <textarea id="tr_obs" rows="2"></textarea></label>
          <hr class="sep">
        </div>

        <div id="blk_waistcoat" style="display:none">
          <h4>Waistcoat — measurements</h4>
          <div class="grid-4">
            <label>Chest <input id="wv_chest" class="len" data-label="Chest" inputmode="decimal"></label>
            <label>Stomach <input id="wv_stomach" class="len" data-label="Stomach" inputmode="decimal"></label>
            <label>Back length <input id="wv_back_length" class="len" data-label="Back length" inputmode="decimal"></label>
          </div>

          <h4>Waistcoat — model & options</h4>
          <div class="grid-3">
            <label>Model
              <select id="wv_model">
                <option>6 button DB with peak lapel</option>
                <option>6 button DB</option>
                <option>4 button SB</option>
                <option>8 button DB</option>
                <option>4 button slanted breast</option>
                <option>5 button SB</option>
                <option>5 button SB with notch lapel</option>
                <option>6 button DB with shawl lapel</option>
                <option>5 triangle button DB</option>
                <option>5 triangle button DB with notch lapel</option>
                <option>5 button SB with shawl lapel</option>
                <option>6 buttons no lapel and low breast</option>
                <option>4 button DB with peak lapel</option>
                <option>6 button DB with shawl lapel (straight hem)</option>
                <option>6 button DB with shawl lapel</option>
              </select>
            </label>
            <label>Back fabric <select id="wv_back_fabric"><option>Same fabric</option><option>Lining fabric</option></select></label>
            <label>Buttons (waistcoat) <select id="wv_buttons_source"><option>Stock service</option><option>Client supplied</option></select></label>
          </div>

          <label>Waistcoat notes <textarea id="wv_obs" rows="2"></textarea></label>
        </div>
      </div>

      <div class="box">
        <h3>Style & Fabric</h3>

        <h4>Fabric</h4>
        <div class="grid-3">
          <label>Source
            <select id="fab_source">
              <option>Stock service (VBC)</option>
              <option>Client supplied (will send)</option>
              <option>Purchased by factory</option>
            </select>
          </label>

          <label id="fab_detail_label">
            <span>Reference / details</span>
            <span id="fab_detail_wrap">
              <!-- dynamic: select or input -->
            </span>
          </label>

          <label>Color name/code <input id="fab_color" type="text" placeholder="optional"></label>
        </div>

        <h4>Lining (global materials)</h4>
        <div class="grid-3">
          <label>Source <select id="lin_source"><option>Stock service</option><option>Client supplied</option></select></label>
          <label>Details / ref. <input id="lin_ref" type="text" placeholder="If client supplied, ref"></label>
        </div>

        <h4>Buttons (jacket/overall)</h4>
        <div class="grid-3">
          <label>Source <select id="btn_source"><option>Stock service</option><option>Client supplied</option></select></label>
          <label>Details / ref. <input id="btn_ref" type="text" placeholder="Horn dark brown, etc."></label>
        </div>

        <h4>Monogram</h4>
        <div class="grid-3">
          <label>Text <input id="sty_mono_text" type="text" maxlength="20" placeholder="optional"></label>
          <label>Color</label>
          ${swatchRow('mono_color','None')}
        </div>
      </div>

      <div class="box">
        <div id="msg" class="notice" style="display:none"></div>
        <div class="actions">
          <button class="btn" id="btn_submit">Submit order</button>
          <button class="btn outline" id="btn_save_client">Save/Update client profile</button>
        </div>
        <div class="small">Submitting sends you an email and logs to Google Sheets. Saving updates the client list.</div>
      </div>
    `,
  };

  /* ========= RENDER ========= */

  document.addEventListener('DOMContentLoaded', ()=>{
    const host = document.getElementById('b2b-app'); if(!host) return;
    host.innerHTML = html.shell();

    // Init units
    $('#unit_sel').addEventListener('change', (e)=>{ UNIT = e.target.value; refreshUnitPlaceholders(); });
    refreshUnitPlaceholders();

    // Items toggle
    const j = $('#it_jacket'), t=$('#it_trouser'), w=$('#it_waistcoat');
    const bj= $('#blk_jacket'), bt=$('#blk_trouser'), bw=$('#blk_waistcoat');
    const toggle = () => { bj.style.display=j.checked?'block':'none'; bt.style.display=t.checked?'block':'none'; bw.style.display=w.checked?'block':'none'; };
    [j,t,w].forEach(i=> i.addEventListener('change', toggle)); toggle();

    // Patch rule
    $('#jk_pockets').addEventListener('change', ()=>{
      const isPatch = $('#jk_pockets').value==='Patch';
      $('#jk_ticket').value = isPatch ? 'No' : $('#jk_ticket').value;
      $('#jk_ticket').disabled = isPatch;
    });

    // Presets (in Jacket customization)
    $('#preset_select').addEventListener('change', ()=>{
      const k = $('#preset_select').value;
      if (!k) return;
      const p = PRESETS[k]?.jacket; if (!p) return;
      $('#jk_pockets').value = p.pockets;
      $('#jk_ticket').value  = p.ticket ? 'Yes' : 'No';
      $('#sty_lapel').value  = p.lapel;
      $('#jk_shoulder_pad').value = p.shoulderPad;
      $('#jk_canvas').value = p.canvas;
      $('#jk_lining').value = p.lining || 'Half';
      $('#jk_amf').value    = p.amf;
      $('#ct_enable').value = (p.contrasts && p.contrasts!=='None')?'Yes':'No';
      $('#ct_block').style.display = $('#ct_enable').value==='Yes' ? 'block' : 'none';
      // if preset had codes we could set them here with selectThread(...)
    });

    // Contrasts conditional
    $('#ct_enable').addEventListener('change', ()=>{
      $('#ct_block').style.display = $('#ct_enable').value==='Yes' ? 'block' : 'none';
    });

    // Swatch visuals
    wireSwatchClicks('#mono_color'); wireSwatchClicks('#ct_lapel'); wireSwatchClicks('#ct_sleeve');

    // Fabric source dynamic field
    const renderFabricDetail = () => {
  const wrap = el('#fab_detail_wrap');
  if (!wrap) return; // evita null
  const v = val('#fab_source');
  if (v.includes('Stock service')) {
    wrap.innerHTML = `<select id="fab_detail_sel">
      ${STOCK_FABRICS.map(s=>`<option>${s}</option>`).join('')}
    </select>`;
  } else {
    wrap.innerHTML = `<input id="fab_detail" type="text" placeholder="Reference / details">`;
  }
};

    $('#fab_source').addEventListener('change', renderFabricDetail);
    renderFabricDetail();

    // Load clients
    loadClients();

    // Actions
    $('#btn_submit').addEventListener('click', submitOrder);
    $('#btn_save_client').addEventListener('click', saveClient);
    $('#client_select').addEventListener('change', onPickClient);
  });

  /* ========= CLIENTS API ========= */

  async function loadClients(){
    const sel = $('#client_select'); if(!cfg.endpoint) return;
    const params = new URLSearchParams({ action:'clients', partner_email: '' });
    try{
      const res = await fetch(cfg.endpoint + '?' + params.toString(), { method:'GET' });
      const data = await res.json();
      if (data && Array.isArray(data.clients)){
        sel.innerHTML = '<option value="">— Select —</option>' +
          data.clients.map(c=>`<option value="${encodeURIComponent(c.id)}">${c.name} — ${c.email||'no email'}</option>`).join('');
      }
    }catch(e){ /* ignore */ }
  }

  function onPickClient(){
    const sel = $('#client_select');
    const opt = sel.selectedOptions[0]; if(!opt || !opt.value) return;
    try{
      const raw = JSON.parse(decodeURIComponent(opt.value));
      $('#client_name').value  = raw.name || '';
      $('#client_email').value = raw.email || '';
      $('#client_phone').value = raw.phone || '';
      if (raw.measurements){
        const m = raw.measurements;
        // Enable blocks if present
        $('#it_jacket').checked = !!m.jacket;
        $('#it_trouser').checked = !!m.trouser;
        $('#it_waistcoat').checked = !!m.waistcoat;
        $('#it_jacket').dispatchEvent(new Event('change'));
        $('#it_trouser').dispatchEvent(new Event('change'));
        $('#it_waistcoat').dispatchEvent(new Event('change'));

        if(m.jacket){
          fill('#jk_biceps', m.jacket.biceps);
          fill('#jk_wrist', m.jacket.wrist);
          fill('#jk_chest', m.jacket.chest);
          fill('#jk_stomach', m.jacket.stomach);
          fill('#jk_shoulder_width', m.jacket.shoulder_width);
          fill('#jk_back_length', m.jacket.back_length);
          fill('#jk_sleeve_length', m.jacket.sleeve_length);
          $('#jk_shoulders_type').value = m.jacket.shoulders_type||'Normal';
          $('#jk_posture_type').value   = m.jacket.posture_type||'Normal';
          $('#jk_chest_type').value     = m.jacket.chest_type||'Normal';
          $('#jk_stomach_type').value   = m.jacket.stomach_type||'Normal';
          if (m.jacket.pockets) $('#jk_pockets').value = m.jacket.pockets;
          if (typeof m.jacket.ticket==='boolean') $('#jk_ticket').value = m.jacket.ticket ? 'Yes' : 'No';
          if (m.jacket.lapel)  $('#sty_lapel').value = m.jacket.lapel;
          if (m.jacket.shoulderPad) $('#jk_shoulder_pad').value = m.jacket.shoulderPad;
          if (m.jacket.canvas) $('#jk_canvas').value = m.jacket.canvas;
          if (m.jacket.lining) $('#jk_lining').value = m.jacket.lining;
          if (m.jacket.amf)    $('#jk_amf').value    = m.jacket.amf;
          if (m.jacket.contrasts && (m.jacket.contrasts.lapel || m.jacket.contrasts.sleeve)){
            $('#ct_enable').value = 'Yes'; $('#ct_block').style.display='block';
            const lap = m.jacket.contrasts.lapel; const slv = m.jacket.contrasts.sleeve;
            selectThread('#ct_lapel',  typeof lap==='object'? (lap.code||'None') : (lap||'None'));
            selectThread('#ct_sleeve', typeof slv==='object'? (slv.code||'None') : (slv||'None'));
          } else {
            $('#ct_enable').value = 'No'; $('#ct_block').style.display='none';
          }
        }
        if(m.trouser){
          fill('#tr_waist', m.trouser.waist);
          fill('#tr_hips', m.trouser.hips);
          fill('#tr_leg_length', m.trouser.leg_length);
          fill('#tr_crotch', m.trouser.crotch);
          fill('#tr_thigh', m.trouser.thigh);
          fill('#tr_knee', m.trouser.knee);
          fill('#tr_calf', m.trouser.calf);
          fill('#tr_cuff', m.trouser.cuff);
          if (m.trouser.pleats) $('#tr_pleats').value = m.trouser.pleats;
          if (m.trouser.back_pockets || m.trouser.backPockets) $('#tr_back_pockets').value = (m.trouser.back_pockets||m.trouser.backPockets);
          if (m.trouser.waistband) $('#tr_waistband').value = m.trouser.waistband;
          if (m.trouser.hem) $('#tr_hem').value = m.trouser.hem;
        }
        if(m.waistcoat){
          fill('#wv_chest', m.waistcoat.chest);
          fill('#wv_stomach', m.waistcoat.stomach);
          fill('#wv_back_length', m.waistcoat.back_length);
          if (m.waistcoat.model) $('#wv_model').value = m.waistcoat.model;
          if (m.waistcoat.back_fabric) $('#wv_back_fabric').value = m.waistcoat.back_fabric;
        }
      }
    }catch(e){}
  }
  function fill(sel, val){ $(sel).value = (val??''); }

  /* ========= COLLECT & VALIDATE ========= */

  function clearErrors(){
    $$('.error-field').forEach(el=> el.classList.remove('error-field'));
    $('#msg').style.display='none';
    $('#msg').textContent='';
    $('#msg').className='notice';
  }
  function markError(sel){ const el=$(sel); if (el) el.classList.add('error-field'); }

function requiredIf(cond, selector, label, errs){
  if (!cond) return;
  const e = el(selector);
  const v = e && 'value' in e ? String(e.value || '').trim() : '';
  if (v === '') {
    errs.push(label);
    if (e) e.classList.add('error-field');
  }
}


  async function collectPayload(){
    clearErrors();
    const errs = [];

    // Convert units; gather files
const height_cm = toCM(val('#client_height'));
const weight_kg = kgFrom(val('#client_weight'));

    // Items required
const jacketOn     = el('#it_jacket')?.checked ?? false;
const trouserOn    = el('#it_trouser')?.checked ?? false;
const waistcoatOn  = el('#it_waistcoat')?.checked ?? false;
    if (!jacketOn && !trouserOn && !waistcoatOn) errs.push('Select at least one item (Jacket / Trouser / Waistcoat).');

    // Required basic
    requiredIf(true, '#client_name', 'Client name', errs);

    // Jacket required fields (minimum)
    if (jacketOn){
      requiredIf(true, '#jk_chest', 'Jacket Chest', errs);
      requiredIf(true, '#jk_stomach', 'Jacket Stomach', errs);
      requiredIf(true, '#jk_shoulder_width', 'Shoulder-to-shoulder', errs);
      requiredIf(true, '#jk_back_length', 'Back jacket length', errs);
      requiredIf(true, '#jk_sleeve_length', 'Sleeve length', errs);
    }
    // Trouser required
    if (trouserOn){
      requiredIf(true, '#tr_waist', 'Trouser Waist', errs);
      requiredIf(true, '#tr_hips', 'Trouser Hips', errs);
      requiredIf(true, '#tr_leg_length', 'Trouser Leg length', errs);
    }
    // Waistcoat required
    if (waistcoatOn){
      requiredIf(true, '#wv_chest', 'Waistcoat Chest', errs);
      requiredIf(true, '#wv_stomach', 'Waistcoat Stomach', errs);
      requiredIf(true, '#wv_back_length', 'Waistcoat Back length', errs);
    }

    if (errs.length){
      showMsg('Missing required fields:\n• ' + errs.join('\n• '), 'error');
      throw new Error('Validation failed');
    }

    // Files
    const frontImg = await fileToPayload($('#client_photo_front'));
    const sideImg  = await fileToPayload($('#client_photo_side'));

    // Contrasts (conditional)
const contrasts = (val('#ct_enable') === 'Yes') ? {
  lapel:  getSelectedThread('#ct_lapel'),
  sleeve: getSelectedThread('#ct_sleeve')
} : 'None';


    // Fabric detail value (select or input)
let fabricDetail = '';
const fs = val('#fab_source');
const selNode = el('#fab_detail_sel');
const inpNode = el('#fab_detail');

if (fs.includes('Stock service') && selNode) {
  fabricDetail = selNode.value || '';
} else if (inpNode) {
  fabricDetail = (inpNode.value || '').trim();
} else {
  fabricDetail = ''; // fallback seguro
}


   const jacket = jacketOn ? {
  biceps: toCM(val('#jk_biceps')),
  wrist: toCM(val('#jk_wrist')),
  chest: toCM(val('#jk_chest')),
  stomach: toCM(val('#jk_stomach')),
  shoulder_width: toCM(val('#jk_shoulder_width')),
  back_length: toCM(val('#jk_back_length')),
  sleeve_length: toCM(val('#jk_sleeve_length')),
  shoulders_type: val('#jk_shoulders_type'),
  posture_type: val('#jk_posture_type'),
  chest_type: val('#jk_chest_type'),
  stomach_type: val('#jk_stomach_type'),
  pockets: val('#jk_pockets'),
  ticket:  val('#jk_ticket') === 'Yes',
  shoulderPad: val('#jk_shoulder_pad'),
  canvas: val('#jk_canvas'),
  lining: val('#jk_lining'),
  amf: val('#jk_amf'),
  contrasts,
  lapel: val('#sty_lapel'),
  obs: val('#jk_obs').trim()
} : null;

const trouser = trouserOn ? {
  waist: toCM(val('#tr_waist')),
  hips: toCM(val('#tr_hips')),
  leg_length: toCM(val('#tr_leg_length')),
  crotch: toCM(val('#tr_crotch')),
  thigh: toCM(val('#tr_thigh')),
  knee: toCM(val('#tr_knee')),
  calf: toCM(val('#tr_calf')),
  cuff: toCM(val('#tr_cuff')),
  pleats: val('#tr_pleats'),
  back_pockets: val('#tr_back_pockets'),
  waistband: val('#tr_waistband'),
  hem: val('#tr_hem'),
  buttons:{ source: val('#tr_buttons_source'), ref: val('#tr_buttons_ref').trim() },
  obs: val('#tr_obs').trim()
} : null;

const waistcoat = waistcoatOn ? {
  chest: toCM(val('#wv_chest')),
  stomach: toCM(val('#wv_stomach')),
  back_length: toCM(val('#wv_back_length')),
  model: val('#wv_model'),
  back_fabric: val('#wv_back_fabric'),
  buttons:{ source: val('#wv_buttons_source') },
  obs: val('#wv_obs').trim()
} : null;


    const items = [];
    if (jacket)   items.push({type:'jacket', ...jacket});
    if (trouser)  items.push({type:'trouser', ...trouser});
    if (waistcoat)items.push({type:'waistcoat', ...waistcoat});

    return {
      partner_name: $('#partner_name').value.trim(),
      partner_email: $('#partner_email').value.trim(),
      units_used: UNIT, // for debugging/awareness

      client_name: $('#client_name').value.trim(),
      client_email: $('#client_email').value.trim(),
      client_phone: $('#client_phone').value.trim(),
      client_height_cm: height_cm,
      client_weight_kg: weight_kg,

      client_photo_front: frontImg, // {name,type,data} or null
      client_photo_side:  sideImg,

      notes: $('#notes').value.trim(),

      style: {
  fabric: { source: fs, detail: fabricDetail, color: val('#fab_color').trim() },
  lining_source: { source: val('#lin_source'), ref: val('#lin_ref').trim() },
  buttons: { source: val('#btn_source'), ref: val('#btn_ref').trim() },
  mono_text: val('#sty_mono_text').trim(),
  mono_color: getSelectedThread('#mono_color')
},


      items, jacket, trouser, waistcoat
    };
  }

  function showMsg(txt, cls=''){ const n=$('#msg'); n.textContent=txt; n.className='notice '+cls; n.style.display='block'; }

  /* ========= ACTIONS ========= */

  async function submitOrder(){
    try{
      const payload = await collectPayload();
      if (!cfg.endpoint) throw new Error('Endpoint not configured.');
      const res = await fetch(cfg.endpoint, {
  method: 'POST',
  headers: { 'Content-Type': 'text/plain;charset=utf-8' }, // simple request (no preflight)
  body: JSON.stringify({ action:'order', ...payload })
      });
      const j = await res.json();
      if (!j.ok) throw new Error(j.error||'Failed to submit');
      showMsg('Order submitted successfully. A confirmation email was sent.', 'success');
    }catch(e){
      if (e.message!=='Validation failed') showMsg('Submit failed: '+e.message, 'error');
    }
  }

  async function saveClient(){
    try{
      const payload = await collectPayload(); // reuse validation (name + required fields for selected items)
      if (!cfg.endpoint) throw new Error('Endpoint not configured.');
      const res = await fetch(cfg.endpoint, {
  method: 'POST',
  headers: { 'Content-Type': 'text/plain;charset=utf-8' }, // simple request
  body: JSON.stringify({ action:'save_client', ...payload })
      });

      const j = await res.json();
      if (!j.ok) throw new Error(j.error||'Failed to save');
      showMsg('Client profile saved/updated.', 'success');
      loadClients();
    }catch(e){
      if (e.message!=='Validation failed') showMsg('Save failed: '+e.message, 'error');
    }
  }

})();
